module.exports = __webpack_public_path__ + "assets/media/2_highleveloutcomes.be93c4d9.svg";